import React, { useEffect, useState } from 'react';
import {
  IonContent,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
} from '@ionic/react';

import { CapacitorHttp } from '@capacitor/core';

import { useLocation } from 'react-router-dom';
import './Menu.css';

import {LoginData, ChatRoom, translateAndParseMarkdown, calculateRoomName, calculateMultiAvatars } from '../Utils';

// const labels = ['New Chat', 'Settings', 'About'];

const Menu: React.FC<{loginData: LoginData}> = ({loginData}) => {
  const location = useLocation();

  const { uid: myUid, csrfToken, wrappedCookies } = loginData;

  const [chatPages, setChatPages] = useState<ChatRoom[]>([]);
  const [ encounteredError, setEncounteredError ] = useState<boolean>(false);

  useEffect(() => {
    const chatsEndpoint = "https://api.browsedns.net/api/v3/chats";

    const options = {
      url: chatsEndpoint,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken,
        "X-Cookie": wrappedCookies
      }
    }
    
    CapacitorHttp.get(options)
      .then(response => {
        const data = response.data;
        if (data && data.status && data.status.code === "ok") {
          const { response: { rooms } }: { response: { rooms: ChatRoom[] } } = data;
          setChatPages(rooms);
        }
      }).catch(() => {
        setEncounteredError(true);
      });
  
  }, []);

  if (encounteredError) {
    return (
      <IonMenu contentId="main" type="reveal">
        <IonContent>
          <IonList id="inbox-list">
            <IonListHeader>Recent Chats</IonListHeader>
            <IonNote>Failed to load chat data. Are you online?</IonNote>
            <IonNote>Please try again later.</IonNote>
          </IonList>
        </IonContent>
      </IonMenu>
    );
  }

  return (
    <IonMenu contentId="main" type="reveal">
      <IonContent>
        <IonList id="inbox-list">
          <IonListHeader>Recent Chats</IonListHeader>
          <IonNote>BrowseDNS</IonNote>
          {chatPages.map((chatPage, index) => {

            const { userCount } = chatPage;

            const teaserText = translateAndParseMarkdown(chatPage?.teaser?.content) ?? 'N/A';
            let teaserFrom = <span></span>;
            if (chatPage?.teaser?.user?.uid === myUid) {
              teaserFrom = <strong>You:&nbsp;</strong>;
            } else if (userCount > 2) {
              teaserFrom = <strong>{chatPage?.teaser?.user?.displayname}:&nbsp;</strong>;
            }

            const roomName = calculateRoomName(chatPage);

            return (
              <IonMenuToggle key={index} autoHide={false}>
                <IonItem className={location.pathname === `/page/${chatPage.roomId}` ? 'selected' : ''} routerLink={`${chatPage.roomId}`} routerDirection="none" lines="none" detail={false}> 
                  <div className="menu-avatar">
                    {calculateMultiAvatars(chatPage)}
                  </div>
                  <div className="menu-item">
                    <IonLabel>{roomName}</IonLabel>
                    <IonNote className="teaser-text">{teaserFrom}<span>{teaserText}</span></IonNote>
                  </div>
                </IonItem>
              </IonMenuToggle>
            );
          })}
        </IonList>
        <IonList id="labels-list">
          <IonListHeader>Labels</IonListHeader>
          {/* {labels.map((label, index) => (
            <IonItem lines="none" key={index}>
              <IonIcon aria-hidden="true" slot="start" icon={bookmarkOutline} />
              <IonLabel>{label}</IonLabel>
            </IonItem>
          ))} */}
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export default Menu;
